// Modules
import React from "react";

// Interfaces
import Resort from "Interfaces/ResortInterface";

// Components
import MvIcon from "Generic/MvIcon";

type Props = {
  resort:Resort;
  id:string;
  onRemove(resortIds:string[]):void;
}

class ResortDropdownSelected extends React.Component<Props, {}> {
  constructor(props:Props) {
    super(props);
    this.click = this.click.bind(this);
    this.removeOnSpace = this.removeOnSpace.bind(this);
  }

  click() {
    this.props.onRemove([this.props.id]);
  }

  removeOnSpace(event: React.KeyboardEvent<HTMLLIElement>) {
    switch (event.keyCode) {
      case 32:
        event.preventDefault();
        this.props.onRemove([this.props.id]);
      break;
    }
  }

  render() {
    return (
      <li className="single-selected" tabIndex={3} onKeyDown={this.removeOnSpace}>
        <span className="remove-selected" onClick={this.click} >
          <MvIcon
            color="rgb(51, 51, 51)"
            height="14px"
            width="14px"
            icon="times"
          />
        </span>
        <p>{this.props.resort.name}</p>
      </li>
    );
  }
}
export default ResortDropdownSelected;
